import { Controller } from "@hotwired/stimulus"
import { getRecaptchaToken } from "../lib/recaptcha"

export default class extends Controller {
  static targets = ["formState", "successState", "emailInput", "successEmail"]
  static values = { recaptchaSiteKey: String }

  async submit(event) {
    event.preventDefault()
    const email = this.emailInputTarget.value
    if (!email) return

    const form = event.target
    const formData = new FormData(form)

    const token = await this._getRecaptchaToken()
    if (token) formData.append('g-recaptcha-response', token)

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
          'Accept': 'application/json'
        }
      })

      if (response.ok) {
        this.successEmailTarget.textContent = `Thanks! We'll be in touch at ${email}`
        this.formStateTarget.style.display = 'none'
        this.successStateTarget.style.display = ''
      } else {
        const data = await response.json()
        alert(data.error || 'Something went wrong. Please try again.')
      }
    } catch {
      alert('Network error. Please try again.')
    }
  }

  _getRecaptchaToken() {
    return getRecaptchaToken(this.recaptchaSiteKeyValue, 'lead_capture')
  }
}
